import React from "react";
import { Link } from "react-router-dom";
import RedirectToLive from "../containers/RedirectToLive";

const Races = (props) => {
  const {
    raceList,
    ExecuteUpdate,
  } = props;

  const content = raceList.map((race, i) =>
    <tr className={`d-flex ${race.isLive ? "live" : ""}`} key={i}>

      {/* <td className="col-md-4">{race.EventName} </td>
      <td className="text-center col-md-2">
        <Link to={`${race.startListLink}`}>Startlist</Link>
      </td>
      <td className="text-center col-md-2">
        <Link to={`${race.resultsLink}`}>Results</Link>
      </td>
      <td className="text-center col-md-2">
        {race.fileExistsStartList === true ? <Link to={race.fileStartListPath} target="_blank">Startlist</Link> : 'Startlist'}
      </td>
      <td className="text-center col-md-2">
        {race.fileExistsResults === true ? <Link to={race.fileResultstPath} target="_blank">Results</Link> : 'Results'}
      </td> */}

      {/* Sin arhivos */}
      <td className="col-md-6">{race.EventName} </td>
      <td className="text-center col-md-3">
        <Link to={`${race.startListLink}`}>Startlist</Link>
      </td>
      <td className="text-center col-md-3">
        <Link to={`${race.resultsLink}`}>Results</Link>
      </td>
    </tr>
  );


  return (
    <div className="container">
      <RedirectToLive Update={ExecuteUpdate} />
      <h1>Races:</h1>
      <br />
      <table className="table">
        <thead>
          <tr className="d-flex">
            {/* <th className="col-md-4">Event Name</th>
            <th className="text-center col-md-4" colSpan="2"></th>
            <th className="text-center col-md-4" colSpan="2">PDF</th> */}

            {/* Sin archivos */}
            <th className="col-md-6">Event Name</th>
            <th className="text-center col-md-6" colSpan="2"></th>

          </tr>
        </thead>
        <tbody>
          {content}
        </tbody>
      </table>
      <br />
      <br />
    </div>
  );
};

export default Races;  